var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_68",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m65.58,33.85v54.54c0,.55-.45,1-1,1h-28.82c-.55,0-1-.45-1-1v-54.54c0-.55.45-1,1-1h7.58c.552,0,1-.448,1-1v-13.4c0-.552.448-1,1-1h9.32c.552,0,1,.448,1,1v13.4c0,.552.448,1,1,1h7.92c.55,0,1,.45,1,1Z",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m54.351,17.45h-8.763l-.751-4.786c-.096-.61.343-1.166.921-1.166h8.423c.578,0,1.017.556.921,1.166l-.751,4.786Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }